/* eslint-disable */
// HTML original de la guía "Actívate en MenuThere HOY MISMO" (intacta)
const guideBody = `
    
    <!-- Progress Bar -->
    <div class="progress-bar" id="progressBar"></div>
    
    <!-- Sticky Navigation -->
    <nav class="sticky-nav">
        <div class="container mx-auto px-4 py-4 flex items-center justify-between flex-wrap">
            <div class="flex items-center">
                <img src="/images/menuthere-logo-full-new.svg" alt="MenuThere" style="height: 40px;">
            </div>
            <div class="flex gap-6 flex-wrap mt-2 md:mt-0">
                <a href="#requisitos" class="text-gray-700 hover:text-orange-600 font-semibold transition">1. Requisitos Previos</a>
                <a href="#ruta" class="text-gray-700 hover:text-orange-600 font-semibold transition">2. Ruta de Activación</a>
            </div>
        </div>
    </nav>
    
    <!-- Hero Section -->
    <section class="py-16 md:py-24" style="background: linear-gradient(135deg, #FFF7F0 0%, #FFFFFF 100%);">
        <div class="container mx-auto px-4 text-center">
            <div class="mb-8 fade-in">
                <img src="/images/menuthere-logo-full-new.svg" alt="MenuThere" class="mx-auto" style="height: 80px;">
            </div>
            
            <h1 class="text-4xl md:text-6xl font-bold mb-6 fade-in" style="color: var(--secondary-black);">
                Actívate en MenuThere<br><span style="color: var(--primary-orange);">HOY MISMO</span>
            </h1>
            
            <p class="text-lg md:text-xl text-gray-700 mb-8 max-w-3xl mx-auto fade-in">
                Guía visual autodirigida en 2 pasos: prepara lo básico y sigue la ruta. Sin conocimientos técnicos. Alta express: en minutos ya estás recibiendo pedidos con <strong style="color: var(--primary-orange);">0% de comisión</strong>.
            </p>
            
            <div class="flex flex-wrap gap-4 justify-center mb-10 fade-in">
                <span class="badge">✅ Plan Free gratis para siempre</span>
                <span class="badge">✅ Sin tarjeta de crédito</span>
                <span class="badge">✅ Solo necesitas WhatsApp</span>
            </div>
            
            <div class="flex flex-wrap gap-4 justify-center mb-12 fade-in">
                <a href="https://menuthere.com/" target="_blank" class="btn-primary" data-track="guia-hero-empezar" data-testid="guia-hero-empezar-link">
                    Empezar en menuthere.com
                </a>
                <a href="https://wa.me/528122626718?text=Hola%20Richard%2C%20quiero%20activar%20MenuThere%20en%20mi%20restaurante" target="_blank" class="btn-whatsapp" data-track="guia-hero-whatsapp" data-testid="guia-hero-whatsapp-link">
                    <i class="fab fa-whatsapp"></i>
                    Hablar con Richard Gower
                </a>
            </div>
            
            <div class="max-w-4xl mx-auto mb-8 fade-in">
                <img src="/images/hero-menu-digital.png" alt="MenuThere Digital Menu" class="rounded-2xl shadow-2xl w-full">
            </div>
            
            <div class="bg-white py-6 px-4 rounded-2xl shadow-lg max-w-2xl mx-auto fade-in">
                <p class="text-lg font-semibold mb-6" style="color: var(--primary-orange);">👇 Esta guía tiene solo 2 secciones. Empieza aquí:</p>
                <div class="grid md:grid-cols-2 gap-4">
                    <a href="#requisitos" class="card text-left">
                        <div class="text-4xl mb-4">1️⃣</div>
                        <h3 class="text-xl font-bold mb-2">Requisitos Previos</h3>
                        <p class="text-gray-600 text-sm">Lo que necesitas tener listo antes de comenzar</p>
                    </a>
                    <a href="#ruta" class="card text-left">
                        <div class="text-4xl mb-4">2️⃣</div>
                        <h3 class="text-xl font-bold mb-2">Ruta de Activación</h3>
                        <p class="text-gray-600 text-sm">Sigue estos 4 pasos para activar MenuThere</p>
                    </a>
                </div>
            </div>
        </div>
    </section>
    
    <!-- Section 1: Requisitos Previos -->
    <section id="requisitos" class="py-16 md:py-24 bg-white">
        <div class="container mx-auto px-4">
            <div class="text-center mb-16 fade-in">
                <h2 class="text-4xl md:text-5xl font-bold mb-6">1️⃣ Requisitos Previos</h2>
                <p class="text-xl text-gray-700 max-w-3xl mx-auto">
                    Antes de darle clic a 'Comenzar', ten esto a la mano. Son cosas que <strong>YA tienes</strong> o consigues en menos de 15 minutos.
                </p>
            </div>
            
            <div class="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
                <!-- Card 1 -->
                <div class="card fade-in">
                    <div class="card-number">1</div>
                    <div class="text-4xl mb-4">📱</div>
                    <h3 class="text-2xl font-bold mb-4">Un smartphone con internet</h3>
                    <p class="text-gray-700 mb-4">
                        Cualquier celular Android o iPhone conectado a datos móviles o WiFi. Con el que usas WhatsApp todos los días es suficiente.
                    </p>
                    <div class="tip-box">
                        <strong>💡 Cómo lo verifico:</strong>
                        <p class="text-sm text-gray-700">Si puedes ver videos de YouTube o mandar fotos por WhatsApp, tu celular funciona perfecto.</p>
                    </div>
                </div>
                
                <!-- Card 2 -->
                <div class="card fade-in">
                    <div class="card-number">2</div>
                    <div class="text-4xl mb-4">📧</div>
                    <h3 class="text-2xl font-bold mb-4">Un correo electrónico activo</h3>
                    <p class="text-gray-700 mb-4">
                        Necesitas un email que revises seguido. Ahí llegará tu contraseña para entrar al panel de MenuThere el Día 0.
                    </p>
                    <div class="tip-box">
                        <strong>💡 Cómo lo consigo:</strong>
                        <p class="text-sm text-gray-700">Si no tienes, crea uno gratis en gmail.com en 2 minutos. Consejo: usa un correo del restaurante (ej. pedidos@turestaurante.com o el tuyo personal).</p>
                    </div>
                </div>
                
                <!-- Card 3 -->
                <div class="card fade-in">
                    <div class="card-number">3</div>
                    <div class="text-4xl mb-4">📄</div>
                    <h3 class="text-2xl font-bold mb-4">Tu menú actual</h3>
                    <p class="text-gray-700 mb-4">
                        En cualquier formato: un PDF, una foto nítida del menú impreso, o una foto de la pizarra. La inteligencia artificial de MenuThere lo lee y digitaliza automáticamente.
                    </p>
                    <div class="tip-box">
                        <strong>💡 Tip:</strong>
                        <p class="text-sm text-gray-700">Si es foto, que se vea plana, con buena luz y sin sombras. No importa si está en Word, Excel o escrito a mano legible.</p>
                    </div>
                </div>
                
                <!-- Card 4 -->
                <div class="card fade-in">
                    <div class="card-number">4</div>
                    <div class="text-4xl mb-4">🎨</div>
                    <h3 class="text-2xl font-bold mb-4">Tu logotipo</h3>
                    <p class="text-gray-700 mb-4">
                        Una imagen del logo de tu restaurante en JPG o PNG. Si no tienes uno formal, sirve una foto de tu letrero, fachada o tarjeta de presentación.
                    </p>
                    <div class="tip-box">
                        <strong>💡 Tip:</strong>
                        <p class="text-sm text-gray-700">Si no tienes logo, MenuThere puede generarlo con IA después. No es un bloqueador.</p>
                    </div>
                </div>
                
                <!-- Card 5 - DESTACADA -->
                <div class="card fade-in" style="border: 3px solid var(--primary-orange); box-shadow: 0 8px 30px rgba(255, 102, 18, 0.2);">
                    <div class="card-number">5</div>
                    <div class="flex items-center gap-2 mb-4">
                        <div class="text-4xl">🟢</div>
                        <span style="background: var(--primary-orange); color: white; padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 700;">⭐ MUY IMPORTANTE</span>
                    </div>
                    <h3 class="text-2xl font-bold mb-4">WhatsApp Business INSTALADO</h3>
                    <p class="text-gray-700 mb-4">
                        Esta es la única cosa <strong>TÉCNICA</strong> que necesitas descargar. Es una app GRATUITA y diferente al WhatsApp normal. Sirve para que tu negocio se vea profesional y para conectar con MenuThere y recibir pedidos automáticos.
                    </p>
                    
                    <div style="background: rgba(255, 102, 18, 0.1); padding: 20px; border-radius: 12px; margin-bottom: 16px;">
                        <h4 class="font-bold mb-3" style="color: var(--primary-orange);">📥 Descárgala en 3 minutos:</h4>
                        <ol class="text-sm text-gray-700" style="list-style-type: upper-alpha;">
                            <li><strong>Abre la tienda de apps</strong> de tu celular (Play Store en Android o App Store en iPhone)</li>
                            <li>En la barra de búsqueda escribe: <strong>"WhatsApp Business"</strong></li>
                            <li>Aparecerá un ícono <strong style="color: var(--whatsapp-green);">VERDE con una letra "B" blanca</strong> adentro. Presiona <strong>"Instalar"</strong> u <strong>"Obtener"</strong></li>
                            <li>Ábrela, acepta términos y <strong>VERIFICA</strong> con el número de tu restaurante. Si ese número YA está en WhatsApp normal, la app te preguntará si quieres migrarlo a Business (di <strong>"Sí"</strong>). Si es un número fijo del restaurante, WhatsApp Business te llamará para dictarte el código.</li>
                        </ol>
                    </div>
                    
                    <div style="background: #FFF5F5; border: 2px solid #E53E3E; padding: 16px; border-radius: 12px; margin-bottom: 16px;">
                        <p class="text-sm font-bold" style="color: #E53E3E;">⚠️ IMPORTANTE: Usa un número dedicado al restaurante, no tu WhatsApp personal donde te escribe tu suegra 😄</p>
                    </div>
                    
                    <div class="tip-box">
                        <strong>💡 Sub-nota:</strong>
                        <p class="text-sm text-gray-700">Después de instalar, completa el perfil de empresa yendo a: <strong>Ajustes → Herramientas para la empresa → Perfil de la empresa</strong>. Pon: nombre del negocio, foto (tu logo o fachada), descripción corta, dirección física, horario y correo.</p>
                    </div>
                </div>
                
                <!-- Card 6 -->
                <div class="card fade-in">
                    <div class="card-number">6</div>
                    <div class="text-4xl mb-4">🗺️</div>
                    <h3 class="text-2xl font-bold mb-4">Perfil de Google Business (aunque esté incompleto)</h3>
                    <p class="text-gray-700 mb-4">
                        Si tu restaurante ya aparece cuando alguien te busca en Google Maps, ¡perfecto! No importa que la ficha esté a medias o desactualizada. MenuThere va a arreglarla y llenarla por ti automáticamente en el Paso 3.
                    </p>
                    <div class="tip-box">
                        <strong>💡 Cómo verifico si tengo perfil:</strong>
                        <p class="text-sm text-gray-700">Abre Google Maps en tu celular, busca el nombre de tu restaurante. Si aparece con foto, dirección o reseñas → SÍ tienes perfil. Si no aparece, crea uno gratis en https://business.google.com/ (te pedirán verificar con un código por correo postal, tarda 5 días, pero puedes seguir con MenuThere mientras tanto).</p>
                    </div>
                </div>
            </div>
            
            <!-- Checklist Final -->
            <div class="max-w-4xl mx-auto mt-16 fade-in">
                <div class="checklist">
                    <h3 class="text-2xl font-bold mb-6 text-center" style="color: var(--primary-orange);">🎯 REVISA TU LISTA ANTES DE PASAR AL PASO 2:</h3>
                    <div class="space-y-2">
                        <div class="checklist-item">
                            <i class="far fa-square"></i>
                            <span>Celular con internet</span>
                        </div>
                        <div class="checklist-item">
                            <i class="far fa-square"></i>
                            <span>Correo electrónico funcionando</span>
                        </div>
                        <div class="checklist-item">
                            <i class="far fa-square"></i>
                            <span>Menú actual (foto o PDF)</span>
                        </div>
                        <div class="checklist-item">
                            <i class="far fa-square"></i>
                            <span>Logo o foto del negocio</span>
                        </div>
                        <div class="checklist-item">
                            <i class="far fa-square"></i>
                            <span>WhatsApp Business instalado y verificado</span>
                        </div>
                        <div class="checklist-item">
                            <i class="far fa-square"></i>
                            <span>Sé que mi restaurante aparece (o casi aparece) en Google Maps</span>
                        </div>
                    </div>
                    <p class="text-center mt-6 text-lg font-bold" style="color: var(--primary-orange);">Si marcaste los 6 → ¡Ya estás listo! Baja al Paso 2 ↓</p>
                </div>
            </div>
        </div>
    </section>
    
    <!-- Section 2: Ruta de Activación -->
    <section id="ruta" class="py-16 md:py-24" style="background: var(--bg-cream);">
        <div class="container mx-auto px-4">
            <div class="text-center mb-16 fade-in">
                <h2 class="text-4xl md:text-5xl font-bold mb-6">2️⃣ Ruta de Activación en 4 Pasos</h2>
                <p class="text-xl text-gray-700 max-w-3xl mx-auto">
                    Sigue estos 4 pasos <strong>EN ORDEN</strong>. Cada uno toma minutos, no días. Es alta express: al terminar ya estás recibiendo pedidos.
                </p>
            </div>
            
            <div class="max-w-5xl mx-auto">
                <div class="timeline">
                    <!-- PASO 1 -->
                    <div id="paso-1" class="timeline-step fade-in">
                        <div class="timeline-number">1</div>
                        <div class="timeline-badge">⏱ Minuto 0</div>
                        <div class="card">
                            <div class="flex items-center gap-3 mb-4">
                                <div class="text-3xl">🟢</div>
                                <h3 class="text-3xl font-bold">Registro Inteligente y Creación de tu Sitio</h3>
                            </div>
                            <p class="text-gray-600 mb-4"><strong>⏱ Duración:</strong> Menos de 2 minutos</p>
                            
                            <div class="step-section">
                                <h4>🎯 Objetivo de este paso</h4>
                                <p>Que MenuThere te genere GRATIS tu propia página web de restaurante en menos de 2 minutos y tengas acceso a tu Panel de Control ("Dashboard").</p>
                            </div>
                            
                            <div class="step-section">
                                <h4>👉 Qué hacer, paso a paso</h4>
                                <ol>
                                    <li>En el navegador de tu celular o computadora, ve a: <strong><a href="https://menuthere.com/" target="_blank" style="color: var(--primary-orange);" data-track="paso-1-link-menuthere" data-testid="paso-1-link-menuthere">https://menuthere.com/</a></strong></li>
                                    <li>En la parte superior derecha, presiona el botón <strong>"Get Started"</strong> o <strong>"Comenzar"</strong> (color naranja).</li>
                                    <li><strong>Escribe el nombre EXACTO de tu restaurante</strong> — el mismo que aparece en tu fachada o en Google Maps. Ejemplo: "Tacos El Buen Sabor de Doña Chelo".</li>
                                    <li>MenuThere hace magia: usa la tecnología de <strong>Google Maps</strong> para encontrar tu negocio automáticamente y traer tu dirección, teléfono y datos base sin que los tengas que capturar. Aparecerá una lista, selecciona tu restaurante.</li>
                                    <li><strong>Escribe tu correo electrónico</strong> (el que preparaste en Requisitos).</li>
                                    <li><strong>Sube tu menú actual</strong>: le das clic al botón "Subir menú" y eliges el PDF o la foto de tu carta que ya tenías lista.</li>
                                    <li><strong>Sube tu logotipo</strong>: igual, botón para subir imagen JPG/PNG.</li>
                                    <li>Presiona <strong>"Crear mi sitio"</strong> (o el botón principal naranja).</li>
                                    <li>En 30-60 segundos ya verás en pantalla tu nuevo sitio web funcionando. Arriba aparecerá un botón que dice <strong>"Go to Dashboard"</strong> (Ir al Panel de Control). Dale clic.</li>
                                    <li><strong>Revisa tu correo electrónico</strong> — te llegó un mensaje de MenuThere con tu contraseña de acceso. Guárdala o anótala.</li>
                                </ol>
                            </div>
                            
                            <div class="my-4">
                                <img src="/images/paso1-menu-movil.png" alt="Menú digital en móvil" class="rounded-lg shadow-lg w-full">
                            </div>
                            
                            <div class="step-section">
                                <h4>👁 Qué vas a ver en pantalla</h4>
                                <p>Un sitio web con el nombre de tu restaurante, tu logo arriba, tu dirección y menú ya cargados. En la parte superior, un botón naranja "Go to Dashboard".</p>
                            </div>
                            
                            <div class="step-section tips">
                                <h4>💡 Tips del consultor</h4>
                                <ul>
                                    <li>El plan Free es 100% GRATIS para siempre (50 pedidos al mes, 0% comisión). Si quieres Lite o Pro tienes 7 días de prueba gratis. Revisa los planes y precios en pesos en la página principal.</li>
                                    <li>Anota tu correo y contraseña en un papel o en las notas del celular. La vas a usar todos los días.</li>
                                    <li>No te preocupes si el menú se ve un poco desacomodado — lo arreglamos en el Paso 2.</li>
                                </ul>
                            </div>
                            
                            <div class="step-section success">
                                <h4>✅ Ya lo lograste si</h4>
                                <p>Entraste al Dashboard con tu correo y contraseña, y ves tu restaurante con menú y logo cargados.</p>
                            </div>
                            
                            <div class="step-section warning">
                                <h4>⚠ Si te atoras</h4>
                                <p>Manda un WhatsApp a Richard Gower al <a href="https://wa.me/528122626718?text=PASO%201" target="_blank" style="color: var(--whatsapp-green); font-weight: 600;" data-track="paso-1-whatsapp" data-testid="paso-1-whatsapp-link">+52 81 2262 6718</a> con el texto <strong>"PASO 1"</strong>.</p>
                            </div>
                        </div>
                    </div>
                    
                    <!-- PASO 2 -->
                    <div id="paso-2" class="timeline-step fade-in">
                        <div class="timeline-number">2</div>
                        <div class="timeline-badge">⏱ Minutos 5 a 20</div>
                        <div class="card">
                            <div class="flex items-center gap-3 mb-4">
                                <div class="text-3xl">🎨</div>
                                <h3 class="text-3xl font-bold">Digitalización del Menú y Diseño</h3>
                            </div>
                            <p class="text-gray-600 mb-4"><strong>⏱ Duración:</strong> 30-60 minutos, en horario tranquilo del negocio</p>
                            
                            <div class="step-section">
                                <h4>🎯 Objetivo de este paso</h4>
                                <p>Que tu menú digital se vea PROFESIONAL, con fotos apetitosas, precios correctos, y platillos estratégicamente destacados para vender más.</p>
                            </div>
                            
                            <div class="step-section">
                                <h4>👉 Qué hacer, paso a paso</h4>
                                <ol>
                                    <li>Entra a tu Dashboard de MenuThere con el correo y contraseña que te llegaron.</li>
                                    <li>En el menú lateral izquierdo busca la sección <strong>"Menu"</strong> o <strong>"Menú"</strong>.</li>
                                    <li>La INTELIGENCIA ARTIFICIAL de MenuThere ya procesó el menú que subiste. Verás los platillos organizados en CATEGORÍAS (Entradas, Fuertes, Bebidas, Postres, etc.).</li>
                                    <li><strong>REVISA CADA PLATILLO</strong> (esta es la parte importante):
                                        <ul style="margin-top: 8px; padding-left: 20px;">
                                            <li>¿El nombre está bien escrito?</li>
                                            <li>¿El precio es el actual (importante si acaba de haber inflación)?</li>
                                            <li>¿La descripción se entiende?</li>
                                            <li>Si algo está mal, dale clic al platillo y edita el campo.</li>
                                        </ul>
                                    </li>
                                    <li><strong>AGREGA FOTOS APETITOSAS a cada platillo</strong>. Tienes 3 opciones:
                                        <ul style="margin-top: 8px; padding-left: 20px;">
                                            <li><strong>Opción A (mejor):</strong> Sube tus propias fotos si ya tienes. Foto plana, con buena luz natural.</li>
                                            <li><strong>Opción B (rápida):</strong> Elige de la GALERÍA PROFESIONAL de MenuThere. Ya tienen miles de fotos genéricas de platillos mexicanos, italianos, hamburguesas, etc.</li>
                                            <li><strong>Opción C (mágica):</strong> Usa el botón <strong>"Generar con IA"</strong>. La inteligencia artificial de MenuThere crea la foto ideal del platillo con solo tener el nombre.</li>
                                        </ul>
                                    </li>
                                    <li><strong>INGENIERÍA DE MENÚ (secreto para ganar más):</strong> para tus 3-5 platillos más rentables (los que dejan más ganancia), activa el toggle (interruptor) que dice <strong>"Best Seller"</strong> o <strong>"Must Try"</strong>. Esto los pinta con una etiqueta llamativa y hace que los clientes los pidan más. Esto es psicología de venta comprobada.</li>
                                    <li><strong>PERSONALIZA LOS COLORES:</strong> en la sección "Design" o "Diseño", elige la paleta de colores que combine con tu marca. Si tu restaurante es de comida mexicana, usa verde/rojo. Si es café, colores tierra. Si es moderno, negro con acento naranja.</li>
                                    <li><strong>ACTIVA EL MODO OSCURO</strong> (opcional): en Ajustes del Dashboard. Sirve para que tus meseros que ven la pantalla en la noche no se cansen los ojos.</li>
                                </ol>
                            </div>
                            
                            <div class="my-4">
                                <img src="/images/paso2-productos.jpg" alt="Interfaz con productos" class="rounded-lg shadow-lg w-full">
                            </div>
                            
                            <div class="step-section">
                                <h4>👁 Qué vas a ver en pantalla</h4>
                                <p>Tu menú digital con platillos ordenados en categorías. Cada uno con foto, nombre, precio, descripción, y algunos con etiqueta naranja "🔥 Best Seller" o "⭐ Must Try".</p>
                            </div>
                            
                            <div class="step-section tips">
                                <h4>💡 Tips del consultor</h4>
                                <ul>
                                    <li>Empieza por marcar tus 3 mejores platillos como "Best Seller". No exageres marcando 20, porque pierde efecto.</li>
                                    <li>Las descripciones cortas y sensoriales venden más. "Tacos al pastor" ✗ vs "Tacos al pastor marinados 24 horas en piña fresca y adobo secreto de la abuela" ✓.</li>
                                    <li>No pases más de 1 hora en este paso hoy. Puedes seguir ajustando después.</li>
                                </ul>
                            </div>
                            
                            <div class="step-section success">
                                <h4>✅ Ya lo lograste si</h4>
                                <p>Tu menú tiene TODAS las categorías, TODOS los platillos con precio correcto, y al menos 3 platillos marcados como "Best Seller".</p>
                            </div>
                            
                            <div class="step-section warning">
                                <h4>⚠ Si te atoras</h4>
                                <p>WhatsApp a Richard Gower con el texto <strong>"PASO 2"</strong>: <a href="https://wa.me/528122626718?text=PASO%202" target="_blank" style="color: var(--whatsapp-green); font-weight: 600;" data-track="paso-2-whatsapp" data-testid="paso-2-whatsapp-link">+52 81 2262 6718</a></p>
                            </div>
                        </div>
                    </div>
                    
                    <!-- PASO 3 -->
                    <div id="paso-3" class="timeline-step fade-in">
                        <div class="timeline-number">3</div>
                        <div class="timeline-badge">⏱ Minutos 20 a 40</div>
                        <div class="card">
                            <div class="flex items-center gap-3 mb-4">
                                <div class="text-3xl">🗺️</div>
                                <h3 class="text-3xl font-bold">Sincronización con Google Maps</h3>
                            </div>
                            <p class="text-gray-600 mb-4"><strong>⏱ Duración:</strong> 5-10 minutos</p>
                            
                            <div class="step-section">
                                <h4>🎯 Objetivo de este paso</h4>
                                <p>Que cuando alguien busque tu restaurante en Google, aparezca con TODO tu menú, precios, fotos actualizadas — y llegue hasta 7 veces más gente a pedir.</p>
                            </div>
                            
                            <div class="step-section">
                                <h4>👉 Qué hacer, paso a paso</h4>
                                <ol>
                                    <li>En tu Dashboard de MenuThere, busca en el menú lateral la sección <strong>"Integrations"</strong> o <strong>"Integraciones"</strong> (icono de engranajes o cadenitas).</li>
                                    <li>Busca el bloque que dice <strong>"Google Business Profile"</strong> o "Google My Business". Dale clic al botón <strong>"Connect"</strong> o <strong>"Conectar"</strong>.</li>
                                    <li>Se abrirá una ventana de Google pidiéndote que INICIES SESIÓN con la misma cuenta de Gmail donde tienes registrado tu negocio en Google. Ejemplo: si abriste el perfil de tu restaurante con juanperez@gmail.com, entra con esa misma cuenta.</li>
                                    <li>Google te pedirá permiso para que MenuThere sea "Manager" de tu perfil. <strong>PRESIONA "ACEPTAR" o "AUTHORIZE"</strong>. No te preocupes, MenuThere solo puede modificar el menú y las fotos, no puede borrar tu negocio ni cambiar reseñas.</li>
                                    <li>Cuando regreses al Dashboard, verás que aparece tu negocio conectado con un checkmark verde ✓.</li>
                                    <li>Aparecerá un botón grande naranja que dice <strong>"Sync"</strong> o <strong>"Sincronizar"</strong>. <strong>PRESIÓNALO</strong>.</li>
                                    <li>Espera 30-60 segundos. MenuThere está exportando tu menú, precios, fotos y categorías directo a tu ficha de Google Maps.</li>
                                    <li><strong>VERIFICA en tu celular:</strong> abre Google Maps, busca el nombre de tu restaurante, y baja hasta la sección "Menú". Ahora aparecen todos tus platillos con foto y precio. 🎉</li>
                                </ol>
                            </div>
                            
                            <div class="my-4">
                                <img src="/images/paso3-google-business.png" alt="Google Business menu" class="rounded-lg shadow-lg w-full">
                            </div>
                            
                            <div class="step-section">
                                <h4>👁 Qué vas a ver en pantalla</h4>
                                <p><strong>En el Dashboard:</strong> un checkmark verde y un aviso "Google Business Profile conectado ✓" y "Última sincronización: hace X minutos".</p>
                                <p><strong>En Google Maps:</strong> tu ficha de negocio ahora muestra el menú completo con precios y fotos apetitosas.</p>
                            </div>
                            
                            <div class="step-section tips">
                                <h4>💡 Tips del consultor</h4>
                                <ul>
                                    <li>Si tu perfil de Google Business todavía NO está verificado (o sea, no aparece del todo en Maps), Google te va a mandar un código por correo postal para verificarlo. Tarda 5 días. Puedes esperar o seguir con el Paso 4 mientras.</li>
                                    <li>Un perfil completo atrae <strong>7X más clics</strong> que uno incompleto (con menú vacío o sin fotos). Es como pasar de un local sin luces a un local con letrero neón brillante.</li>
                                    <li>MenuThere se sincroniza automáticamente cada vez que cambies un precio o platillo. No tienes que hacerlo cada vez.</li>
                                </ul>
                            </div>
                            
                            <div class="step-section success">
                                <h4>✅ Ya lo lograste si</h4>
                                <p>Buscas tu restaurante en Google Maps y ves tu menú completo con fotos, precios y categorías.</p>
                            </div>
                            
                            <div class="step-section warning">
                                <h4>⚠ Si te atoras</h4>
                                <p>WhatsApp con el texto <strong>"PASO 3"</strong>: <a href="https://wa.me/528122626718?text=PASO%203" target="_blank" style="color: var(--whatsapp-green); font-weight: 600;" data-track="paso-3-whatsapp" data-testid="paso-3-whatsapp-link">+52 81 2262 6718</a></p>
                            </div>
                        </div>
                    </div>
                    
                    <!-- PASO 4 -->
                    <div id="paso-4" class="timeline-step fade-in">
                        <div class="timeline-number">4</div>
                        <div class="timeline-badge">⏱ Minutos 40 a 60</div>
                        <div class="card">
                            <div class="flex items-center gap-3 mb-4">
                                <div class="text-3xl">💬</div>
                                <h3 class="text-3xl font-bold">Activación de WhatsApp y Recepción de Pedidos</h3>
                            </div>
                            <p class="text-gray-600 mb-4"><strong>⏱ Duración:</strong> 5 minutos de configuración + práctica de pedido con un familiar</p>
                            
                            <div class="step-section">
                                <h4>🎯 Objetivo de este paso</h4>
                                <p>Que cuando un cliente te escriba "Hola" por WhatsApp, RECIBA AUTOMÁTICAMENTE un menú digital súper fácil para pedir — y tú recibas el pedido con TODO tu dinero, sin comisiones.</p>
                            </div>
                            
                            <div class="step-section">
                                <h4>👉 Qué hacer, paso a paso</h4>
                                <ol>
                                    <li>En tu Dashboard de MenuThere, busca en la sección "Integrations" el bloque de <strong>"WhatsApp Ordering"</strong>.</li>
                                    <li>Presiona <strong>"Connect WhatsApp"</strong> o <strong>"Conectar WhatsApp"</strong>.</li>
                                    <li>Aquí escribes el NÚMERO DE WHATSAPP BUSINESS que instalaste en los Requisitos Previos. Formato: código de país + número (ej. +52 81 1234 5678).</li>
                                    <li>MenuThere te enviará un código de verificación a ese WhatsApp. Ábrelo en tu celular, cópialo y pégalo en el Dashboard.</li>
                                    <li><strong>¡LISTO!</strong> El número está conectado.</li>
                                    <li><strong>AHORA VAMOS A PROBAR</strong> (súper importante):
                                        <ul style="margin-top: 8px; padding-left: 20px;">
                                            <li>Con TU celular, o pídele a un familiar/amigo, que abra WhatsApp y le mande al número del restaurante un mensaje que diga simplemente: <strong>"Hola"</strong>.</li>
                                            <li>En 2-3 segundos, el cliente recibirá automáticamente un mensaje de bienvenida CON UN ENLACE que dice tipo: "¡Bienvenido a Tacos El Buen Sabor! Haz tu pedido aquí 👉 [enlace mágico]".</li>
                                            <li>Que le den clic al enlace. Se abre una página bonita con TU menú digital con TU logo y colores.</li>
                                            <li>El cliente elige platillos, los agrega al carrito visual, ve el total automáticamente, escribe su dirección y presiona <strong>"Confirmar pedido"</strong>.</li>
                                            <li>El pedido te llega inmediatamente al Dashboard con nombre, dirección, teléfono y todo el detalle. Suena una alerta y ya lo puedes preparar.</li>
                                        </ul>
                                    </li>
                                </ol>
                            </div>
                            
                            <div class="my-4">
                                <img src="/images/paso4-whatsapp-ordering.png" alt="WhatsApp ordering flow" class="rounded-lg shadow-lg w-full">
                            </div>
                            
                            <div class="step-section">
                                <h4>👁 Qué vas a ver en pantalla</h4>
                                <p><strong>En el celular del cliente:</strong> mensaje automático de tu restaurante con el enlace mágico → menú digital → carrito → confirmación.</p>
                                <p><strong>En tu Dashboard:</strong> pedido nuevo con todos los datos, botón "Aceptar" y "Iniciar preparación".</p>
                            </div>
                            
                            <div class="step-section tips">
                                <h4>💡 Tips del consultor</h4>
                                <ul>
                                    <li>El enlace que recibe el cliente es de UN SOLO USO y expira en 10 minutos. Es súper seguro — ni siquiera tiene contraseña. Cero fricción para el cliente.</li>
                                    <li>El cliente NO necesita descargar ninguna app. Todo pasa dentro de su navegador de celular.</li>
                                    <li>Cuando alguien pide, te queda REGISTRADO su nombre, teléfono e historial. Puedes hacerle promociones después. Eso los agregadores como Uber Eats NUNCA te lo dan.</li>
                                    <li>Pega un pequeño letrero en la mesa o en la caja: "¿Quieres pedir para llevar? 📱 Manda 'Hola' al 81 XXXX XXXX" — así conviertes a tu cliente presencial en cliente digital directo.</li>
                                </ul>
                            </div>
                            
                            <div class="step-section success">
                                <h4>✅ Ya lo lograste si</h4>
                                <p>Hiciste un pedido de prueba desde otro celular y llegó a tu Dashboard. En ese momento, técnicamente, ¡acabas de recibir tu primer pedido con 0% de comisión! 🎉💰</p>
                            </div>
                            
                            <div class="step-section warning">
                                <h4>⚠ Si te atoras</h4>
                                <p>WhatsApp con el texto <strong>"PASO 4"</strong>: <a href="https://wa.me/528122626718?text=PASO%204" target="_blank" style="color: var(--whatsapp-green); font-weight: 600;" data-track="paso-4-whatsapp" data-testid="paso-4-whatsapp-link">+52 81 2262 6718</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <!-- Final Section -->
    <section class="py-16 md:py-24 bg-white">
        <div class="container mx-auto px-4 text-center">
            <div class="max-w-4xl mx-auto fade-in">
                <div class="text-6xl mb-8">🎉</div>
                <h2 class="text-4xl md:text-5xl font-bold mb-6" style="color: var(--primary-orange);">¡FELICIDADES!</h2>
                <h3 class="text-3xl md:text-4xl font-bold mb-8">Ya estás activo en MenuThere</h3>
                <p class="text-xl text-gray-700 mb-12 max-w-2xl mx-auto">
                    Cada peso que factures a partir de HOY se queda <strong>100% en tu caja</strong>. Cero comisiones. Sin intermediarios. Sin decisiones ajenas.
                </p>
                
                <div class="flex flex-wrap gap-4 justify-center mb-12">
                    <a href="https://menuthere.com/" target="_blank" class="btn-primary" data-track="cierre-volver-menuthere" data-testid="cierre-volver-menuthere-link">
                        Volver a menuthere.com
                    </a>
                    <a href="https://wa.me/528122626718?text=Hola%20Richard%2C%20quiero%20activar%20MenuThere%20en%20mi%20restaurante" target="_blank" class="btn-whatsapp" data-track="cierre-necesito-ayuda" data-testid="cierre-necesito-ayuda-link">
                        <i class="fab fa-whatsapp"></i>
                        Necesito ayuda — Richard Gower
                    </a>
                </div>
            </div>
        </div>
    </section>
    


    <!-- Footer -->
    <footer class="py-12" style="background: var(--secondary-black); color: white;">
        <div class="container mx-auto px-4">
            <div class="text-center mb-8">
                <img src="/images/menuthere-logo-full-new.svg" alt="MenuThere" class="mx-auto mb-6" style="height: 50px; filter: brightness(0) invert(1);">
                <p class="text-gray-400 mb-6">La plataforma de pedidos con 0% de comisión para restaurantes</p>
            </div>
            
            <div class="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-8 text-center md:text-left">
                <div>
                    <h4 class="font-bold mb-4">Producto</h4>
                    <ul class="space-y-2 text-gray-400">
                        <li><a href="https://menuthere.com/" target="_blank" class="hover:text-orange-500 transition">Inicio</a></li>
                        <li><a href="https://menuthere.com/product/digital-menu" target="_blank" class="hover:text-orange-500 transition">Menú Digital</a></li>
                        <li><a href="https://menuthere.com/solutions/whatsapp-ordering" target="_blank" class="hover:text-orange-500 transition">WhatsApp Ordering</a></li>
                        <li><a href="https://menuthere.com/solutions/google-business" target="_blank" class="hover:text-orange-500 transition">Google Business Sync</a></li>
                    </ul>
                </div>
                
                <div>
                    <h4 class="font-bold mb-4">Soporte</h4>
                    <ul class="space-y-2 text-gray-400">
                        <li><a href="https://wa.me/528122626718?text=Hola%20Richard%2C%20quiero%20activar%20MenuThere%20en%20mi%20restaurante" target="_blank" class="hover:text-orange-500 transition" data-track="footer-whatsapp" data-testid="footer-whatsapp-link">WhatsApp: +52 81 2262 6718</a></li>
                        <li><a href="mailto:richard@menuthere.com" class="hover:text-orange-500 transition">richard@menuthere.com</a></li>
                    </ul>
                </div>
                
                <div>
                    <h4 class="font-bold mb-4">Recursos</h4>
                    <ul class="space-y-2 text-gray-400">
                        <li><a href="https://notebook.google.com/notebook/9a560727-adaf-4a9c-abb8-3d40110031b5/preview" target="_blank" class="hover:text-orange-500 transition">Notebook LM</a></li>
                        <li><a href="#requisitos" class="hover:text-orange-500 transition">Requisitos Previos</a></li>
                        <li><a href="#ruta" class="hover:text-orange-500 transition">Ruta de Activación</a></li>
                    </ul>
                </div>
            </div>
            
            <div class="text-center text-gray-500 text-sm pt-8 border-t border-gray-800">
                <p>&copy; 2026 MenuThere. Representante oficial México: Richard Gower</p>
            </div>
        </div>
    </footer>
    
`;

export default guideBody;
